<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum odeslání</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.sentAllOwnersDate" [maxToday]="true"/></div>
  </div>
</fieldset>
